// extracted by mini-css-extract-plugin
export var cookieConsentButton = "layout-module--cookieConsentButton--c2aa9";
export var cookieConsentContainer = "layout-module--cookieConsentContainer--96d3b";
export var cookieConsentContent = "layout-module--cookieConsentContent--cf8ac";
export var cookieConsentDeclineButton = "layout-module--cookieConsentDeclineButton--4f86e";